import FavoriteCount from './FavoriteCount';

export default FavoriteCount;
